<template>
  <div class="content">
    <el-row style="height:28px">
      <el-col :span="24">
        <div class="grid-content bg-purple-dark">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>培训考试</el-breadcrumb-item>
            <el-breadcrumb-item>考试统计</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </el-col>
    </el-row>
    <!-- 主体 -->
    <el-container style="height:calc(100% - 30px);width:100%;position: relative;">
      <el-main style="height: 100%;padding:0px !important;  position: relative;width: 100%;">
        <el-card style="height:100% !important;" class="aside">
          <el-row :gutter="20" v-if="!isData">
            <el-col :span="24">
              <el-card shadow="hover" v-for="item in examList" :key="item.id" @click.native="detail(item.id,item.qualified)">
                <div style="display:flex;justify-content:space-between;padding:30px 25px;font-weight:bold">
                  <div>{{item.name}}</div>
                  <div>系统标配</div>
                </div>
                <div style="display:flex;justify-content:space-between;padding:30px  60px;">
                  <div>知识题:{{item.qNumber}}题</div>
                  <div>合格分:{{item.qualified}}分</div>
                  <div>参考人数:{{item.allNum}}人</div>
                   <div>合格率:{{item.rate}}%</div>
                </div>
              </el-card>
            </el-col>
          </el-row>
          <!-- 暂无数据 -->
          <div v-if="isData" class="imgs">   
            <img src="../../assets/image/noData.png" alt="">
            <div>暂无数据</div>
          </div>
        </el-card>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import util from '../../untils/util'
import myHttp from '../../untils/port'
import base from '../../untils/base'
export default {
  data() {
    return {
      search: {},
      groupId:'',
      examList:[
      ],
      groupType:'',
      isData:false      

      
    }
  },
  mounted() {
    this.groupId = this.$store.state.groupId
    if ('' == this.groupId) {
      this.$store.commit('setGroupId')
      this.groupId = this.$store.state.groupId
    }
    this.getInfo()
    if (util.session.get('roleId') == '3') {
      this.groupType = '3'
    } else if (this.$store.state.roleId == '4') {
      this.groupType = '1'
    } else if (this.$store.state.roleId == '5') {
      this.groupType = '2'
    }
  },
  methods: {
    detail(id,score){
      // console.log(1111)
      if(this.groupType==1){
        this.$router.push({ path: '/testDetailPro/' +id +'/'+score})
      }else{
        this.$router.push({ path: '/testDetail/' +id+'/'+score })
      }
      
    },
   // 获取视频课程
    getInfo(){
      var that = this
      myHttp
        .projectPaperStatistical({
            projectId:this.groupId
        })
        .then(
          function (resp) {
            if (resp.data.code == '200') {
            var list = resp.data.data.Paper ||[]
             for(var i=0;i<list.length;i++){
               if(list[i].allNum){
                    list[i].rate =((parseInt(list[i].hg))/list[i].allNum *100).toFixed(2)  
               }else{
                 list[i].rate =0
               }     
             }
              if(list.length==0){
                that.isData = true
              }else{
                that.isData = false
              }
             that.examList = list
            } else {
               this.$message.error(resp.msg)
            }
          },
          function () {}
        )
    },
  }
}
</script>
<style>
@import '../../assets/css/common.css';
</style>
<style scoped>
.content >>> .el-card__body {
  padding: 0 !important;
  height: 100% !important;
  overflow: auto;
}
.grid-content {
  height: 2.5vh;
  font-size: 1.6vh;
}
.aside {
  box-shadow: rgba(8, 42, 51, 0.1) 0px 0px 7px 0px !important;
  border-radius: 10px !important;
  border: 0px !important;
  background-color: #ecf0f5;
  display: flex;
  flex-direction: column;
}
.el-card .is-hover-shadow{
 margin-bottom: 20px;
 cursor: pointer;
}
.imgs {
  width: 100%;
  height: 100%;
  /* display: table-cell; */
  vertical-align: middle;
  text-align: center;
  /* border: 1px solid #000; */
}
.imgs > img {
  width: 200px;
  /* height: 200px; */
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.imgs > div {
  width: 200px;
  /* height: 200px; */
  position: absolute;
  top: 62%;
  left: 50%;
  transform: translate(-60%, -50%);
  font-weight: bolder;
  color: #6b6b6b;
}
</style>